export const INIT_SEARCH_APP = 'INIT_SEARCH_APP'
